import { createFileRoute } from '@tanstack/react-router';

import { requireGuest } from '@/app/lib/auth-guard';
import { ResetPasswordPage } from '@/auth/pages/reset-password';

export const Route = createFileRoute('/users/reset-password/$token')({
  beforeLoad: () => {
    requireGuest();
  },
  component: ResetPasswordRoute
});

function ResetPasswordRoute() {
  const { token } = Route.useParams();

  return <ResetPasswordPage token={token}/>;
}
